import React, { useEffect, useState, useCallback } from 'react';
import { filterResponsive, pageTitle, rightResponsive } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import SemenFilter from '../Components/SemenFilter';
import SemenCard from '../Components/SemenCard';
import { filterSemens, getSemenBuyers } from '../Api/semenMarketApi';
import ActionButton from '../../../components/ActionButton';

const TAKE = 10;

const initialFilters = {
    stallionName: null,
    priceFrom: null,
    priceTo: null,
    ownerId: null,
    skip: 0,
    take: TAKE,
};

export default function SemenMarketListPage() {
    const { translate } = useTranslate();

    const [filters, setFilters] = useState(initialFilters);
    const [horses, setHorses] = useState([]);
    const [buyers, setBuyers] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
    const [totalCount, setTotalCount] = useState(0);

    const hasMore = horses.length < totalCount;

    const fetchSemens = useCallback(async (newFilters, append = false) => {
        const { sort, ...apiFilters } = newFilters;

        const res = await filterSemens(apiFilters);
        setTotalCount(res?.totalCount || 0);
        setHorses(prev =>
            append ? [...prev, ...(res?.result ?? [])] : res?.result ?? []
        );
    }, []);

    useEffect(() => {
        const init = async () => {
            const buyersRes = await getSemenBuyers();
            setBuyers(buyersRes || []);

            const firstBuyer = buyersRes?.[0];
            if (!firstBuyer) return;

            const newFilters = {
                ...initialFilters,
                ownerId: firstBuyer.id,
            };

            setActiveTab(firstBuyer.name);
            setFilters(newFilters);
            fetchSemens(newFilters);
        };

        init();
    }, [fetchSemens]);

    const handleSortChange = (e) => {
        const sortValue = e.target.value;
        const newFilters = {
            ...filters,
            sort: sortValue,
            skip: 0,
        };

        setFilters(newFilters);
        fetchSemens(newFilters);
    };

    const handleFilter = (filterArgs) => {
        const newFilters = {
            ...filters,
            ...filterArgs,
            skip: 0,
        };

        setFilters(newFilters);
        fetchSemens(newFilters);
    };

    const handleTabClick = (buyerName) => {
        const buyer = buyers.find(b => b.name === buyerName);

        const newFilters = {
            ...filters,
            ownerId: buyer?.id || null,
            skip: 0,
        };

        setActiveTab(buyerName);
        setFilters(newFilters);
        fetchSemens(newFilters);
    };

    const handleLoadMore = () => {
        const newFilters = {
            ...filters,
            skip: filters.skip + filters.take,
        };

        setFilters(newFilters);
        fetchSemens(newFilters, true);
    };

    const sortedHorses = [...horses];
    if (filters.sort === 'asc') {
        sortedHorses.sort((a, b) => (a.price || 0) - (b.price || 0));
    } else if (filters.sort === 'desc') {
        sortedHorses.sort((a, b) => (b.price || 0) - (a.price || 0));
    }

    return (
        <div className="row rtl">
            <h2 className={pageTitle}>
                {translate('web.semenMarket', 'Semen Market')}
            </h2>

            <div className={filterResponsive}>
                <SemenFilter submit={handleFilter} />
            </div>

            <div className={rightResponsive}>
                <div className="d-flex justify-content-end mb-3">
                    <select
                        className="form-select"
                        style={{ width: '200px', cursor: 'pointer' }}
                        value={filters.sort || ''}
                        onChange={handleSortChange}
                    >
                        <option value="">{translate('web.sort', 'Sort')}</option>
                        <option value="asc">{translate('web.priceLowToHigh', 'Price: Low to High')}</option>
                        <option value="desc">{translate('web.priceHighToLow', 'Price: High to Low')}</option>
                    </select>
                </div>

                <div className="row second_section_bar" style={{ justifyContent: 'flex-start' }}>
                    {[...new Set(buyers.map(b => b?.name))].map((name) => (
                        <div
                            key={name}
                            className="col-lg-4 col-md-4 col-sm-6 col-8 my-2 text-center px-0"
                            style={{ minWidth: 250, cursor: 'pointer' }}
                            onClick={() => handleTabClick(name)}
                        >
                            <span
                                className={`${activeTab === name ? 'fw-bold' : ''} capatalize_text`}
                                style={{ fontSize: 14 }}
                            >
                                {name}
                            </span>

                            <div
                                className="service_bar_underline"
                                style={
                                    activeTab === name
                                        ? { border: '3px solid var(--mainGold)', marginTop: 16 }
                                        : {}
                                }
                            />
                        </div>
                    ))}
                </div>

                <div className="row">
                    {sortedHorses.map(item => (
                        <SemenCard key={item.id} horse={item} />
                    ))}
                </div>

                {hasMore && (
                    <div className="col-12 my-5 text-center">
                        <ActionButton
                            label={translate('web.loadMore', 'Load More')}
                            type="loadmore"
                            onClick={handleLoadMore}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}